import { connect } from "react-redux";
import PaymentInvoiceRequestDetails from "./paymentInvoiceRequestDetails";
import { bindActionCreators } from "redux";
import { getVendorRequestSubmit,getPaymentRequestDetails,getVendorPo,saveVendorPayment,getInvoiceRequestDetail,getRequestedInvoiceRequestDetail } from "services/redux/sales/vendorPortal/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";


import {
  fetchZones,
} from "services/redux/sales/preSaleListing/action";
import {approvalVendorPaymentRequest} from "services/redux/sales/vendorPortal/action";

const mapStateToProps = (state) => ({
  getVendorDetails: state.vendorPortalReducer.vendorPaymentAdd,
  poDetail: state.vendorPortalReducer.poDetail,
  invoiceRequestDetail:state.vendorPortalReducer.invoiceRequestDetail,
  requestInvoiceRequestDetail:state.vendorPortalReducer.requestInvoiceRequestDetail,

});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchZones,
      getVendorRequestSubmit,
      getPaymentRequestDetails,
      getVendorPo,
      saveVendorPayment,
      documentUploadUrl,
      getInvoiceRequestDetail,
      getRequestedInvoiceRequestDetail,
      approvalVendorPaymentRequest
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PaymentInvoiceRequestDetails);
